import { forwardRef, type Ref, type SVGProps } from "react";
const IconHearingAidOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M20.415 2.05a1.06 1.06 0 0 0-1.333.696c-.178.564.13 1.166.689 1.346 4.465 1.436 6.932 6.255 5.51 10.764-.178.563.13 1.166.689 1.345a1.06 1.06 0 0 0 1.333-.695c1.778-5.636-1.306-11.66-6.888-13.455" />
    <path d="M8.225 23.275c.142.21.424.28.637.28.212 0 .495-.14.636-.35.212-.21 2.122-2.171 2.122-4.343 0-1.016-.408-1.745-.8-2.447l-.12-.214-.054-.098c-.411-.745-.865-1.567-.865-2.775 0-2.171 1.556-3.712 3.748-3.712 2.05 0 3.748 1.681 3.748 3.713 0 .49-.07.98-.283 1.47-.212.42 0 .981.495 1.191.424.21.99 0 1.202-.49.354-.7.495-1.471.495-2.242 0-3.012-2.475-5.533-5.586-5.533-3.183 0-5.587 2.381-5.587 5.534 0 1.82.636 2.942 1.202 3.852.354.63.637 1.191.637 1.751 0 1.261-1.203 2.662-1.627 3.083-.354.35-.354.98 0 1.33" />
    <path
      fillRule="evenodd"
      d="M12.893 4.082h.636a9.297 9.297 0 0 1 9.335 9.317 9.22 9.22 0 0 1-4.88 8.125c-.495.28-.778.84-.707 1.401v.63c0 3.573-2.97 6.445-6.577 6.445-.283 0-.566 0-.848-.07-3.253-.42-5.658-3.362-5.658-6.655V13.68c0-4.974 3.748-9.247 8.699-9.597m8.132 9.247c0-4.133-3.394-7.426-7.496-7.426-.106 0-.194.018-.283.035a1.4 1.4 0 0 1-.283.035c-3.89.28-6.93 3.643-6.93 7.706v9.526c0 2.452 1.697 4.554 4.03 4.834.213.07.425.07.637.07 2.546 0 4.668-2.102 4.668-4.623v-.42c-.142-1.332.565-2.592 1.697-3.223 2.475-1.33 3.96-3.783 3.96-6.514"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconHearingAidOutlineSVG);
ForwardRef.displayName = "IconHearingAidOutline";
export { ForwardRef as IconHearingAidOutline };
